import axios from 'axios';
import { AeratorSubtype } from 'views/self-service/features/aerators/types/aerator-sub-type.enum';
import { AeratorType } from 'views/self-service/features/aerators/types/aerator-type.enum';
import { Aerator } from 'views/self-service/features/aerators/types/aerators.type';

// GET AERATORS
// /ewosapi/v1/shrimps/aerator/{globalCompanyId}
export const getAerators = async (globalCompanyId: string): Promise<Aerator[]> => {
  const res = await axios.get(`/ewosapi/v1/shrimps/aerator/${globalCompanyId}`);
  return res.data;
};

export const getAeratorTypes = async (globalCompanyId: string): Promise<AeratorType[]> => {
  const res = await axios.get(`/ewosapi/v1/shrimps/aerator/type?globalCompanyId=${globalCompanyId}`);
  return res.data;
};

export const getAeratorSubtypes = async (globalCompanyId: string): Promise<AeratorSubtype[]> => {
  const res = await axios.get(`/ewosapi/v1/shrimps/aerator/subtype?globalCompanyId=${globalCompanyId}`);
  return res.data;
};
